"use strict";

exports.__esModule = true;
var _CreateCommentActionElement = require("./CreateCommentActionElement");
Object.keys(_CreateCommentActionElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreateCommentActionElement[key]) return;
  exports[key] = _CreateCommentActionElement[key];
});
var _CreateCommentActionDialog = require("./CreateCommentActionDialog");
Object.keys(_CreateCommentActionDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreateCommentActionDialog[key]) return;
  exports[key] = _CreateCommentActionDialog[key];
});
var _SelectDefaultCommentFields = require("./SelectDefaultCommentFields");
Object.keys(_SelectDefaultCommentFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SelectDefaultCommentFields[key]) return;
  exports[key] = _SelectDefaultCommentFields[key];
});
var _action = require("./action");
Object.keys(_action).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _action[key]) return;
  exports[key] = _action[key];
});